import React, {useContext} from 'react';
import {BrowserRouter as Router} from 'react-router-dom';
import {Route, Switch} from 'react-router'
import './App.scss';
import {
    About, FeaturedPage, FoodBeveragesPage, Home,
    LegalDisclaimer, MenuIdeaDetailPage, MenuIdeas, NewsEventsDetailPage, NewsEventsPage, PageNotFound, ProductCategoryPage, ProductDetailPage, SearchPage,
} from './pages';
//import { PublicLayout } from './layout';
import HeaderLayout from "./layout/Headers";
import FooterLayout from "./layout/Footers";
import {ThanksPage} from "./pages/ThanksPage";
import ModalResponsive from "./components/UI/Modal/ModalResponsive";
import ReactGa from 'react-ga';
import {Context} from "./context/Wrapper";

// import * as Sentry from "@sentry/react";

// const path = (/#!(\/.*)$/.exec(window.location.hash) || [])[1];
const initializeAnalytics = () => {
    ReactGa.initialize('UA-175183149-3');
    ReactGa.pageview(window.location.origin.toString());
};

const App = () => {
    const context = useContext(Context);
    initializeAnalytics();

    // function FallbackComponent() {
    //     return <div>An error has occurred</div>;
    // }

    return (
        <>
            {/*start browser*/}
            {/*<Sentry.ErrorBoundary fallback={FallbackComponent} showDialog>*/}
            <Router basename={"/"}>
                <HeaderLayout selectLang={context.selectLang}/>
                {typeof window !== undefined ?
                    window.innerWidth < 360 ? <ModalResponsive/> :
                        <Switch>
                            {/*<Loading/>*/}
                            <Route path="/" exact component={Home}/>
                            <Route path="/about" component={About}/>
                            <Route path="/product-categories/:id" exact component={ProductCategoryPage}/>
                            <Route path="/product-categories/:id/:sub_category_slug" component={ProductCategoryPage}/>
                            <Route path="/product-detail/:id" component={ProductDetailPage}/>
                            <Route path="/menu-ideas" component={MenuIdeas}/>
                            <Route path="/menu-ideas-search/:id" component={MenuIdeas}/>
                            <Route path="/menu-ideas-detail/:id" component={MenuIdeaDetailPage}/>
                            <Route path="/search-products/:id" component={SearchPage}/>
                            <Route path="/featured-products" component={FeaturedPage}/>
                            <Route path="/news-events" component={NewsEventsPage}/>
                            <Route path="/news-events-detail/:id" component={NewsEventsDetailPage}/>
                            <Route path="/disclaimer-policy" component={LegalDisclaimer}/>
                            <Route path="/terms-and-conditions" component={LegalDisclaimer}/>
                            <Route path="/thanks-page" component={ThanksPage}/>
                            <Route path="/food-beverages-detail/:id" component={FoodBeveragesPage}/>
                            <Route path="/page-not-found" component={PageNotFound}/>
                            <Route component={PageNotFound}/>
                        </Switch>
                    : ''
                }
                <FooterLayout/>
                {/*</Switch>*/}
            </Router>
            {/*</Sentry.ErrorBoundary>*/}
            {/*start browser*/}
        </>
    );
}

export default App;